<template>
  <div class="pageyscRecharge">
    <XR-head :titleText="chainCname + '充值'" :rightShow="false"></XR-head>    
    <div class="total account-address">
      <p class="title">充值需知：</p>
      <p class="desc">如有充值问题，请联系：{{siteConfigInfo.Phone}}或QQ：{{siteConfigInfo.QQ}}。</p>
      <p class="tip">请打开资产钱包商城充值页面，给以下地址充值即可</p>
      <p class="address">{{UserInfo.Purse}}</p>
      <p class="copybtn" @click="copyText()">复制地址</p>
    </div>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
import siteconfig from '../../../../util/siteconfigCache'
export default {
  data() {
    return {
      siteConfigInfo: {},
      yscInfo: {},
      UserInfo:{
        Purse:''
      }
    };
  },
  mounted :function(){
    this.$refs.XRtoast.load()
    this.siteConfigInfo = siteconfig.getSiteconfig()

    this.getUserInfo()
    this.getyscInfo()
  },
  methods: {
    getUserInfo: function() {
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetUserInfo"
      ).then(function(res) {
        if(res.IsSuccess){        
          ths.UserInfo = res.Data;
        }
      });
    },
    getyscInfo: function() {
      var ths = this;   
      ths.$post(
        "/Shop/yscServer/GetyscAccountInfo"
      ).then(function(res) {
        if(!res.IsSuccess){          
          if(res.TypeId == 1){
            ths.$router.push("/usercenter/yscActive")
          }
          if(res.TypeId == ErrorCode.SessionMissing){
            ths.$router.push("/Login")
          }
        }else{          
          ths.yscInfo = res.Data;
          ths.loaded=false
          ths.$refs.XRtoast.hide()
        }
      });
    },
    copyText: function(){
    var oInput = document.createElement('input')
        oInput.value = this.UserInfo.Purse
        document.body.appendChild(oInput)
        oInput.select()
        document.execCommand("Copy")
        document.body.removeChild(oInput)
        this.$refs.XRtoast.success("复制成功", true)
    }
    
  }
};
</script>
<style>
#app .pageyscRecharge{
  bottom: 0;
  background: white;
}
.pageyscRecharge .total{
  background: white;
  padding: 20px 20px;
}
.pageyscRecharge .title{
  line-height: 24px;
  font-size: 14px;
  color:red;
}
.pageyscRecharge .account-address .desc{    
  padding: 10px 0 0;
  font-size: 12px;
  color:#999;
}
.pageyscRecharge .account-address .tip{    
  padding: 10px 0 0;
  font-size: 12px;
  padding: 30px 0 0;
}
.pageyscRecharge .money{
  font-size: 46px;
  color:red;
  line-height: 42px;
  padding: 10px 0 10px;
  letter-spacing: -1px;
}
.pageyscRecharge .account-address{
  margin-bottom: 10px;
}
.pageyscRecharge .account-address .address {
  font-size:12px;
  color:black;
  background:#efefef;
  margin: 20px 0;
  height:50px;
  line-height:50px;
  text-align: center;
}
.pageyscRecharge .account-address .copybtn{
  text-align: center;
  font-size: 12px;
  color:Red;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/ysc/local/yscRecharge.vue